import voop from './audio/voop.mp3';
import uwa from './audio/uwa.mp3';
import woosh from './audio/woosh.mp3';
import trum from './audio/trum.mp3';
import todo from './audio/todo.mp3';
import bloop from './audio/bloop.mp3';
import { SoundSettingsEnum } from '@common/components/Notifications/enums/soundSettings.enum';
import { toValue } from 'vue';
export var useNotificationSound = function () {
    var _a;
    var audio = new Audio();
    var audioSrc = (_a = {},
        _a[SoundSettingsEnum.UWA] = uwa,
        _a[SoundSettingsEnum.TODO] = todo,
        _a[SoundSettingsEnum.VOOP] = voop,
        _a[SoundSettingsEnum.TRUM] = trum,
        _a[SoundSettingsEnum.BLOOP] = bloop,
        _a[SoundSettingsEnum.WOOSH] = woosh,
        _a);
    var play = function (sound) {
        if (sound === SoundSettingsEnum.DISABLED)
            return;
        var soundValue = toValue(sound);
        audio.src = audioSrc[soundValue];
        audio.play();
    };
    return {
        play: play,
    };
};
